import type {
    ICampaignCreatorPayoutApplied,
    ICampaignCreatorPayoutFeeBreakdown,
} from '../types/global/campaignFeeBreakdown.types';

export interface IResolvedCreatorPayoutDisplay {
    viewerHasActiveSubscription: boolean;
    applied: ICampaignCreatorPayoutApplied | null | undefined;
    extraVsNonSubscribersUsd: number | null;
    showUpsell: boolean;
    showSubscribedBenefit: boolean;
}

function diffNetUsd(
    subscribed?: ICampaignCreatorPayoutApplied | null,
    unsubscribed?: ICampaignCreatorPayoutApplied | null,
): number | null {
    const subNet = subscribed?.net_amount_usd;
    const unsubNet = unsubscribed?.net_amount_usd;
    if (subNet == null || unsubNet == null || !Number.isFinite(subNet) || !Number.isFinite(unsubNet)) {
        return null;
    }
    const diff = subNet - unsubNet;
    return diff > 0 ? diff : null;
}

/** Merge API breakdown with client subscription state for campaign detail payout UI. */
export function resolveCreatorPayoutForViewer(
    breakdown: ICampaignCreatorPayoutFeeBreakdown,
    clientHasActiveSubscription: boolean,
): IResolvedCreatorPayoutDisplay {
    const apiSubscribed = Boolean(breakdown.viewer_has_active_subscription);
    const viewerHasActiveSubscription = apiSubscribed || clientHasActiveSubscription;

    const applied = viewerHasActiveSubscription
        ? apiSubscribed
            ? breakdown.applied
            : breakdown.if_subscribed ?? breakdown.applied
        : apiSubscribed
        ? breakdown.if_not_subscribed ?? breakdown.applied
        : breakdown.applied;

    const extraVsNonSubscribersUsd =
        breakdown.subscribe_to_save_usd != null && breakdown.subscribe_to_save_usd > 0
            ? breakdown.subscribe_to_save_usd
            : diffNetUsd(breakdown.if_subscribed, breakdown.if_not_subscribed);

    const hasExtra = extraVsNonSubscribersUsd != null && extraVsNonSubscribersUsd > 0;

    return {
        viewerHasActiveSubscription,
        applied,
        extraVsNonSubscribersUsd,
        showUpsell: !viewerHasActiveSubscription && hasExtra,
        showSubscribedBenefit: viewerHasActiveSubscription && hasExtra,
    };
}
